import AdtInfoDataPanel from "./adtInfoDataPanel.container";

export default AdtInfoDataPanel;
